var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "todo-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部类型" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.taskType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "taskType", $$v)
                        },
                        expression: "searchForm.taskType",
                      },
                    },
                    _vm._l(_vm.taskTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "默认待处理" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待处理", value: "open" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完成", value: "done" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已取消", value: "cancelled" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "角色" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部角色" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.roleCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "roleCode", $$v)
                        },
                        expression: "searchForm.roleCode",
                      },
                    },
                    _vm._l(_vm.roles, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", loading: _vm.rebuilding },
                      on: { click: _vm.rebuild },
                    },
                    [_vm._v("重建投影")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("待办总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.summary.total || 0))]),
          _c("small", [_vm._v("TOTAL")]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("待支付 / 待签字")]),
          _c("strong", [
            _vm._v(_vm._s(_vm.typeCount("pay") + _vm.typeCount("sign"))),
          ]),
          _c("small", [_vm._v("URGENT")]),
        ]),
        _c("div", [
          _c("span", [_vm._v("待采购 / 待签收")]),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.typeCount("purchase") + _vm.typeCount("receipt"))
            ),
          ]),
          _c("small", [_vm._v("MATERIAL")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("待整改")]),
          _c("strong", [_vm._v(_vm._s(_vm.typeCount("rectify")))]),
          _c("small", [_vm._v("QUALITY")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("角色待办台账")]),
                _c("span", [
                  _vm._v(
                    "待办只是业务状态投影，重建不会改合同、工地或订单本身"
                  ),
                ]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taskNo",
                  label: "待办编号",
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.typeTag[row.taskType],
                            },
                          },
                          [_vm._v(_vm._s(_vm.typeText(row.taskType)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "标题", "min-width": "220" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "summary",
                  label: "摘要",
                  "min-width": "240",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "角色", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.roleText(row.roleCode)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTag[row.status],
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "截止", width: "160", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.dueTime || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deepLink",
                  label: "小程序入口",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("ROLE TODO PROJECTION")]),
        _c("h2", [_vm._v("待办中心")]),
        _c("p", [
          _vm._v(
            "按业务状态重建待支付、待签字、待采购、待签收和待整改，供各角色在小程序处理。"
          ),
        ]),
      ]),
      _c("div", { staticClass: "hero-badges" }, [
        _c("b", [_vm._v("角色投影")]),
        _c("b", [_vm._v("可重建")]),
        _c("b", [_vm._v("深链跳转")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }